import { createContext } from 'react';

export const MakeCardPaymentContext = createContext<any[]>([[], () => {}]);
